import { createContext, Dispatch, ReactNode, useContext } from 'react';
import {
  MessageStandaloneDisplayConfigAction,
  MessageStandaloneDisplayConfig,
  useMessageStandaloneConfigReducer,
} from '../hooks/store/useMessageStandaloneDisplayReducer';

export const MessageStandaloneContext = createContext<{
  store: MessageStandaloneDisplayConfig;
  dispatch: Dispatch<MessageStandaloneDisplayConfigAction>;
} | null>(null);

type MessageVisibilityProviderProps = {
  children: ReactNode;
};

export const MessageStandaloneDisplayConfigProvider = ({
  children,
}: MessageVisibilityProviderProps) => {
  const { store, dispatch } = useMessageStandaloneConfigReducer();
  return (
    <MessageStandaloneContext.Provider value={{ store, dispatch }}>
      {children}
    </MessageStandaloneContext.Provider>
  );
};

export const useMessageStandaloneDisplayConfig = () => {
  const context = useContext(MessageStandaloneContext);
  if (!context) {
    throw Error('MessageVisibility is not in the context');
  }
  return {
    displayConfig: context.store,
    displayConfigDispatch: context.dispatch,
  };
};
